import { BaseService } from "../BaseService";

import { MDLResponsePayload } from "./types";

import { Environments } from "@/migrated-widgets/table-map/constants/Environments";
import { mdlAuthToken } from "@/migrated-widgets/table-map/utils/mdlToken";

class MapDataLayerClass extends BaseService {
    constructor() {
        super(`${Environments.MAP_DATA_LAYER_API_URL}/mdl`);
    }
    async get<T = any>(endpoint: string, { token, dealerId, ...params }: MDLResponsePayload): Promise<T> {
        const { data } = await this.axios.get<T>(endpoint, {
            params,
            headers: {
                Authorization: mdlAuthToken(token, String(dealerId).split(",")),
            },
        });

        return { ...data };
    }
}

const MapDataLayerService = new MapDataLayerClass();

export { MapDataLayerService };
